import { render, staticRenderFns } from "./EditCompanyPage.vue?vue&type=template&id=7a8d1f75&"
import script from "./EditCompanyPage.vue?vue&type=script&lang=js&"
export * from "./EditCompanyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8d1f75')) {
      api.createRecord('7a8d1f75', component.options)
    } else {
      api.reload('7a8d1f75', component.options)
    }
    module.hot.accept("./EditCompanyPage.vue?vue&type=template&id=7a8d1f75&", function () {
      api.rerender('7a8d1f75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/EditCompanyPage.vue"
export default component.exports